module.exports = __webpack_public_path__ + "static/media/paraparapam.284e585d.jpg";